module.exports = __webpack_public_path__ + "static/media/text-animation-1s-262x71px.99b1c99f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/text-animation-1s-262x71px.svg
// module id = 407
// module chunks = 0